import React from 'react'
import { Link } from 'react-router-dom'

function Vista() {
  return (
    <div className='font-thin'>
          <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">

{/* ✅ Breadcrumb Navigation */}
<div className="flex justify-start text-sm md:text-base">
       <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
       <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
       <Link to="/display" className="block py-1 pl-4 hover:underline mt-6">Display -</Link>
       <span className="block py-1 pl-4 mt-6">Vista</span>

     </div>
     {/* ✅ Product Image on Top */}
     <div className="flex justify-center mb-6">
       <img src="/images/vista2.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
     </div>

     {/* ✅ Product Title & Description */}
     <div className="text-center mb-6">
       <h1 className="text-3xl md:text-4xl uppercase mb-8">Vista</h1>
       <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">Compact display units with large capacity and superior visibility.</p>
       <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">The VISTA and VISTA SLIM display cases are ideal for small stores and for when every centimetre counts, maximizing product display and product promotion. The range offers up to four tiers fully refrigerated or heated in a very tiny footprint.</p>
     </div>

     {/* ✅ Models & Model Values */}
<h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>

<div className="grid grid-cols-1 gap-4 text-center mb-6">
   <div className="flex flex-col gap-3 md:flex-row justify-center items-center">
     <p className="text-xl lg:text-2xl opacity-90">Pastry, Sandwiches, Cold Dishes and Beverages</p>
     <p className="text-xl font-thin opacity-70"><span className=' text-blue-400'>-1… +7 °C</span> (3M2)</p>
   </div>
   <p className="text-xl lg:text-2xl opacity-90">Chocolates <span className=' text-blue-400'>+13… +15 °C</span> (3S)</p>
   <p className="text-xl lg:text-2xl opacity-90">Packaged Ice Cream and Frozen Desserts <span className=' text-fuchsia-950'>-24... -20 °C</span><span className=' text-gray-400'> (6L1)</span> </p>
   <p className="text-xl lg:text-2xl opacity-90">Hot Food <span className='text-gray-500'>(ventilated, ventilated with humidity control)</span><span className='text-red-500'>+65 °C</span> </p>
   <p className="text-xl lg:text-2xl opacity-90">Bakery and Pastry<span className='text-gray-500'> dry ambient</span> </p>
</div>


     {/* ✅ Refrigeration */}
     <div>
       <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
       <p className="text-xl lg:text-2xl text-lime-500 text-center mt-3">CO2 | Glycol |  R290</p>
     </div>



     {/* ✅ Case Images & Features */}
     <div className="flex flex-col gap-8 md:pt-32">
        {/* case 1 */}
         <div 
           className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
           {/* ✅ Case Points */}
           <div className="w-full md:w-1/2 px-4"> 
    <p className="text-2xl">Don’t waste space, show it all!</p>
    <ul className="list-[square] list-outside text-gray-500">
        <li className="text-xl font-thin opacity-90 mt-6">4 exhibition levels with controlled temperature.</li>
        <li className="text-xl font-thin opacity-90 mt-6">Fan assisted refrigeration which assures an even temperature distribution.</li>
        <li className="text-xl font-thin opacity-90 mt-6">Grab’n’go version with rear doors to make refills easy or closed to lean against the wall.</li>
        <li className="text-xl font-thin opacity-90 mt-6">Maximum energetic efficiency, thanks to the front and side double glazed glasses which reduce temperature loss.</li>
        <li className="text-xl font-thin opacity-90 mt-6">3 design options for front glass: straight (VD), curved (VC) or self/grab’n’go type (VS).</li>
        <li className="text-xl font-thin opacity-90 mt-6">Service doors to access to the exhibition area, pivoting in the 60 and 85 cm models, and sliding in the 125 and 165 cm models.</li>
        <li className="text-xl font-thin opacity-90 mt-6">Folding service cover (optional).</li>
        <li className="text-xl font-thin opacity-90 mt-6">LED lighting of high brightness and high energy efficiency.</li>
    </ul>
</div>
             {/* ✅ Image Wrapper */}
             <div className="w-full md:w-1/2">
             <img src="/images/newdisplaycase.jpg" className="max-w-full h-auto object-contain" />
           </div>
         </div>

        {/* case 2 */}
         <div 
           className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
           {/* ✅ Case Points */}
             {/* ✅ Image Wrapper */}
             <div className="w-full md:w-1/2">
             <img src="/images/newdisplaycase1.jpg" className="max-w-full h-auto object-contain" />
           </div>

           <div className="w-full md:w-1/2 px-4"> 
    <p className="text-2xl">Easy to display, easy to clean!</p>
    <ul className="list-[square] list-outside text-gray-500">
        <li className="text-xl font-thin opacity-90 mt-6">2 options for front glass: straight (VD) or curved (VC).</li>
        <li className="text-xl font-thin opacity-90 mt-6">Bread basket with crumb collector, to make cleaning easier.</li>
        <li className="text-xl font-thin opacity-90 mt-6">Service doors to access to the exhibition area, pivoting in the 60 and 85 cm models, and sliding in the 125 cm model.</li>
        <li className="text-xl font-thin opacity-90 mt-6">LED lighting of high brightness and high energy efficiency.</li>
    </ul>
</div>
         </div>

{/* case 3 */}
<div 
           className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
           {/* ✅ Case Points */}
           <div className="w-full md:w-1/2 px-4"> 
    <p className="text-2xl">Chocolates… and more chocolates!</p>
    <ul className="list-[square] list-outside text-gray-500">
        <li className="text-xl font-thin opacity-90 mt-6">4 níveis de exposição com temperatura controlada.</li>
        <li className="text-xl font-thin opacity-90 mt-6">Fan assisted refrigeration, which assures an even temperature distribution, and humidity control.</li>
        <li className="text-xl font-thin opacity-90 mt-6">Maximum energetic efficiency, thanks to the double front and side glasses, which reduce temperature loss.</li>
        <li className="text-xl font-thin opacity-90 mt-6">2 options for front glass: straight (VD) or curved (VC).</li>
        <li className="text-xl font-thin opacity-90 mt-6">Service doors for access to the exhibition area, pivoting in the 60 and 85 cm models, and sliding in the 125 cm model.</li>
        <li className="text-xl font-thin opacity-90 mt-6">LED lighting of high brightness and high energy efficiency.</li>
    </ul>
</div>
             {/* ✅ Image Wrapper */}
             <div className="w-full md:w-1/2">
             <img src="/images/newdisplaycase2.jpg" className="max-w-full h-auto object-contain" />
           </div>
         </div>

        {/* case 4 */}
        <div 
           className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
           {/* ✅ Case Points */}
          
    {/* ✅ Image Wrapper */}
    <div className="w-full md:w-1/2">
    <img src="/images/newdisplaycase3.jpg" className="max-w-full h-auto object-contain" />
  </div>

  <div className="w-full md:w-1/2 px-4"> 
    <p className="text-2xl">Delicate desserts deserve the greatest care!</p>
    <ul className="list-[square] list-outside text-gray-500">
        <li className="text-xl font-thin opacity-90 mt-6">3 display levels with controlled temperature.</li>
        <li className="text-xl font-thin opacity-90 mt-6">Fan assisted refrigeration, which assures an even temperature distribution.</li>
        <li className="text-xl font-thin opacity-90 mt-6">Straight front glass (VD).</li>
        <li className="text-xl font-thin opacity-90 mt-6">Maximum energetic efficiency, thanks to the triple glazed front and side glasses, which reduce temperature loss.</li>
        <li className="text-xl font-thin opacity-90 mt-6">Doors for access to the exhibition area, pivoting in the 60 and 85 cm models, and sliding in the 125 cm model.</li>
        <li className="text-xl font-thin opacity-90 mt-6">Hot gas defrost.</li>
        <li className="text-xl font-thin opacity-90 mt-6">LED lighting of high brightness and high energy efficiency.</li>
    </ul>
</div>
         </div>

         {/* case 5 */}
<div 
           className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
           {/* ✅ Case Points */}
        
     {/* ✅ Image Wrapper */}
     <div className="w-full md:w-1/2">
     <img src="/images/newdisplaycase4.jpg" className="max-w-full h-auto object-contain" />
   </div>
   <div className="w-full md:w-1/2 px-4"> 
    <p className="text-2xl">Roasted chicken, packaged salads, …, all ready-to-go!</p>
    <ul className="list-[square] list-outside text-gray-500">
        <li className="text-xl font-thin opacity-90 mt-6">4 exhibition levels with controlled temperature.</li>
        <li className="text-xl font-thin opacity-90 mt-6">Fan assisted refrigeration and heating which assures an even temperature distribution.</li>
        <li className="text-xl font-thin opacity-90 mt-6">Grab’n’go model with rear doors to make refills easy or closed to lean against the wall.</li>
        <li className="text-xl font-thin opacity-90 mt-6">Maximum energetic efficiency, thanks to the double-glazed front or side glasses, which reduce temperature loss.</li>
        <li className="text-xl font-thin opacity-90 mt-6">3 options for front glass: straight (VD), curved (VC) or self/grab’n’go type (VS).</li>
        <li className="text-xl font-thin opacity-90 mt-6">Service doors to access exhibition area, pivoting in the 60 and 85 cm models, and sliding in the 125 and 165 cm models.</li>
        <li className="text-xl font-thin opacity-90 mt-6">LED lighting of high brightness and high energy efficiency (refrigerated versions).</li>
    </ul>
</div>
 </div>
     </div>

 </div>

    </div>
  )
}

export default Vista